import { createContext, useContext, type ReactNode } from 'react';

export interface AuthUserProfile {
  id: string;
  name: string;
  email: string;
}

export interface AuthContextValue {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  isProduction?: boolean;
  evoOrganisationId?: string;
  userProfile?: AuthUserProfile;
}

const AuthContext = createContext<AuthContextValue>({});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  isProduction?: boolean;
  evoOrganisationId?: string;
  userProfile?: AuthUserProfile;
  children: ReactNode;
}

export function AuthProvider({ getAccessToken, instanceId, isProduction, evoOrganisationId, userProfile, children }: AuthProviderProps): React.ReactElement {
  return (
    <AuthContext.Provider value={{ getAccessToken, instanceId, isProduction, evoOrganisationId, userProfile }}>
      {children}
    </AuthContext.Provider>
  );
}
